import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import StartPanel from './StartPanel';
import { BaseCard } from '../../../components/wizard';

class StartCard extends Component<any, any> {
  static propTypes: any;
  static defaultProps: any;

  render = () => {
    const { ...extraProps } = this.props;
    return (
      <Box>
        <BaseCard
          cardid={'START'}
          cardname={'Start'}
          cardtitle={'Member Registration'}
          instruction={'Get started with guided member onboarding.'}
          step={0}
          buttons={['CANCEL', 'NEXT', 'GUIDE']}
          {...extraProps}
        >
          <StartPanel />
        </BaseCard>
      </Box>
    );
  };
}

StartCard.propTypes = {
  classes: PropTypes.object,
};

export default StartCard;

